import { render, staticRenderFns } from "./Unauthorizederror.vue?vue&type=template&id=642845e2"
import script from "./Unauthorizederror.vue?vue&type=script&lang=js"
export * from "./Unauthorizederror.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports